var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownRightRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3754 17.0337C21.4709 17.511 21.0501 17.9318 20.5728 17.8364L14.7872 16.6792C14.2529 16.5724 14.0534 15.9133 14.4386 15.528L16.1528 13.8139L12.4494 10.1105L9.5104 13.0495C9.34162 13.2183 9.1127 13.3131 8.874 13.3131C8.63531 13.3131 8.40639 13.2183 8.23761 13.0495L2.8745 7.68637C2.52303 7.3349 2.52303 6.76505 2.8745 6.41358C3.22598 6.06211 3.79583 6.06211 4.1473 6.41358L8.874 11.1403L11.813 8.20128C12.1645 7.84981 12.7343 7.84981 13.0858 8.20128L17.4256 12.5411L19.0671 10.8995C19.4523 10.5143 20.1115 10.7139 20.2183 11.2481L21.3754 17.0337Z",
    fill: "#E73F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRightRed);
export default __webpack_public_path__ + "static/media/ArrowDownRightRed.f7f1dfac20ab1c467735efa7c80bcc96.svg";
export { ForwardRef as ReactComponent };